module.exports = __webpack_public_path__ + "static/media/contactsBlue.387519e3.svg";